export default __webpack_public_path__ + "static/media/OS_TienLen_PHONG BAN - ENG.4f86ab76.png";